import { forwardRef, Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { StoreService } from '@se-po/se-household-setup-data-access-store'
import { PersonaInfo } from '@se-po/shared-data-access-models'

@Injectable({
  providedIn: 'root',
  useExisting: forwardRef(() => ChildInfoSubmitService),
  deps: [Router]
})
export abstract class ChildInfoSubmitter {
  public abstract submit(info: PersonaInfo, store: StoreService): void
}

@Injectable({
  providedIn: 'root'
})
export class ChildInfoSubmitService implements ChildInfoSubmitter {
  public submitting = false

  constructor(
    public router: Router,
  ) { }

  public submit(info: PersonaInfo, store: StoreService): void {
    store.childInfo = info
    this.router.navigate([store.basePath, 'parent-guardian-info'], { queryParamsHandling: 'merge' })
  }
}
